var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _g3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDeskIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_412_1",
    "data-name": "Component 412 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 266.372,
    height: 165.236,
    viewBox: "0 0 266.372 165.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3684",
    "data-name": "Group 3684",
    transform: "translate(-789.365 -325.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3676",
    "data-name": "Group 3676",
    transform: "translate(870.047 406.346)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1796.427,1123.646h.928l1.57-81.053h-4.069Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#5f6169"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1794.857,1042.593h4.069l-.086,4.934-3.949-3.018Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3677",
    "data-name": "Group 3677",
    transform: "translate(796.414 406.346)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1520.338,1123.646h.928l1.57-81.053h-4.068Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1518.768,1042.593h4.068l-.086,3.844-3.948-2.352Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4912",
    "data-name": "Path 4912",
    d: "M1493.2,1041.082h88.109a.864.864,0,0,0,.864-.864h0a.864.864,0,0,0-.864-.864H1493.2a.864.864,0,0,0-.864.864h0A.864.864,0,0,0,1493.2,1041.082Z",
    transform: "translate(-702.974 -633.873)",
    fill: "#555"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(50.487 2.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M230.763,869.4s-6.562,1.024-5.232,8.271,2.483,11.769.975,14.518a2.525,2.525,0,0,0,2.749,3.37c3.724,0,6.721-2.462,5.976-8.768s2.8-.72,2.8-7.636S233.955,866.208,230.763,869.4Z",
    transform: "translate(-215.415 -855.118)",
    fill: "#2b2018"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M255.108,1356.889s-.447,6.908-4.5,9.4a1.689,1.689,0,0,0-.816,1.436h0a1.147,1.147,0,0,0,1.147,1.147h5.851a2.023,2.023,0,0,0,1.891-1.3,12.363,12.363,0,0,0,.844-3.65v4.948h.519l1.119-5.991-.739-5.991Z",
    transform: "translate(-233.035 -1207.231)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M302.718,1356.889s.447,6.908,4.5,9.4a1.689,1.689,0,0,1,.816,1.436h0a1.147,1.147,0,0,1-1.147,1.147h-5.851a2.024,2.024,0,0,1-1.891-1.3,12.366,12.366,0,0,1-.843-3.65v4.948h-.519l-1.119-5.991.739-5.991Z",
    transform: "translate(-266.829 -1207.231)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M228.966,1057.637a68.977,68.977,0,0,0-1.553,14.922c0,8.61,5.827,32.529,5.827,32.529l5.539,32.705h5.485l-.549-36.864-1.138-26.565h1.686l1.406,26.943,1.71,36.486h5.458s1.548-31.672,1.548-32.618,4.008-18.168,4.008-33.585a46.129,46.129,0,0,0-4.462-18.58l-24.981,1.072Z",
    transform: "translate(-216.9 -988.135)",
    fill: "#031162"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M333.863,975.418l5.615,6.662s2.407,7.33,4.382,11.492c1.879,3.958,3.4,7.663,3.4,7.663a15.5,15.5,0,0,0,.658,4,14.568,14.568,0,0,0,2.142,3.346s.844-.062.468-1.046-.973-2.8-.795-2.868a11.109,11.109,0,0,1,1.636,4.291c-.036,1.114.008,1.968.379,2.134s.652-1.042.78-2.32a.887.887,0,0,0,.591-.532,2.476,2.476,0,0,0,0-1.279s.052-.032.2-.357a8.684,8.684,0,0,0-3.142-7.3s-3.463-14.383-5.183-18.894a52.1,52.1,0,0,0-4.711-8.968Z",
    transform: "translate(-293.651 -929.322)",
    fill: "#fe9b7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(44.701 42.118)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M394.551,1073.687a12.583,12.583,0,0,0-1.632-1.891,14.988,14.988,0,0,1,3.008,6.77A10.374,10.374,0,0,0,394.551,1073.687Z",
    transform: "translate(-380.931 -1043.797)",
    fill: "#4a131e"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M361.557,998.427l.007.02c-.772-3.157-3.507-14.19-4.975-18.039a52.1,52.1,0,0,0-4.711-8.968l-1.929,1.2c.638,1.443,2.07,3.3,2.424,4.063.8,1.728,1.767,3.392,2.633,5.089.993,1.946,1.953,3.912,2.781,5.935C359.222,991.224,360.252,994.876,361.557,998.427Z",
    transform: "translate(-349.95 -971.44)",
    fill: "#4a131e"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M212.862,916.132s-13.045-2.321-17.052,12.649l-1.588,2.753s4.446,3.811,8.152,3.811l2.753-4.764s-2.753,5.823.106,8.681-.212,16.621-.212,16.621,10.057,3.6,25.2,0c0,0-2.753-13.127-1.588-16.3s2.435-4.129,1.588-7.834l3.171,3.9a32.074,32.074,0,0,0,8.094-2.706l-2.055-3s-.086-11.331-6.987-13.021-10.568-1.137-10.568-1.137Z",
    transform: "translate(-192.969 -889.134)",
    fill: "#ffe100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M234.2,916.932s-2.654,1.639-1.172,12.649,1.588,28.584-1.165,32.289l-8.046-1.059s3.282-15.774,2.012-19.9-1.482-7.94.529-11.328.212-11.854.212-11.854A16.8,16.8,0,0,1,234.2,916.932Z",
    transform: "translate(-214.309 -889.934)",
    fill: "#1957c2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M297.248,915.386s2.592,6.3,1.428,11.485-1.163,29.748.583,33.348l7.674-1.27s-2.533-23.42-1.9-26c0,0-2.647-11.256.656-16.587C305.688,916.36,303.042,914.794,297.248,915.386Z",
    transform: "translate(-267.251 -888.811)",
    fill: "#1957c2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M239.427,929.946s-.086-11.331-6.987-13.021-10.568-1.137-10.568-1.137l-9.009.345s-13.045-2.321-17.052,12.649l-1.588,2.753a21.928,21.928,0,0,0,4.4,2.825,5.054,5.054,0,0,0,.623-.488c2.589-2.382,2.279-6.589,4.1-9.6a7.694,7.694,0,0,1,7.363-3.563c3.132.393,5.878,2.727,9.033,2.627a16.155,16.155,0,0,0,5.074-1.514c1.659-.63,3.55-1.066,5.175-.352,2.452,1.076,3.159,4.118,4.056,6.641a21.419,21.419,0,0,0,3.643,6.413,25.042,25.042,0,0,0,3.795-1.581Z",
    transform: "translate(-192.969 -889.134)",
    fill: "#4a131e",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(21.879 42.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 5.368,
    height: 8.797,
    rx: 2.613,
    fill: "#031162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M270.438,976.256h0a.364.364,0,0,1-.364-.364v-.85a.364.364,0,0,1,.364-.364h0a.364.364,0,0,1,.364.364v.85A.364.364,0,0,1,270.438,976.256Z",
    transform: "translate(-269.538 -973.775)",
    fill: "#1957c2"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M191.631,974.3a17.287,17.287,0,0,0,7.086,3.281s-1.37,5.3-2.164,6.092l13.065-2.452a1,1,0,0,0,.82-.981c0-.868.182-2.166,1.191-2.537v2.353s6-1.084,6.466-1.084.615.47,0,1.084a4.756,4.756,0,0,1-1.162.878s.927.415.149,1.367a.738.738,0,0,1,.014,1.1s.335.863-.353.863c0,0,.057.594-.673.594s-3,.685-5.182,0c-.951-.3-12.756,4.518-18.4,5.979S191.631,974.3,191.631,974.3Z",
    transform: "translate(-189.732 -931.383)",
    fill: "#fe9b7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M203.625,986.491c-3.633.952-6.313.607-9.52,2.562-.527.321-1.18.663-1.724.371a1.693,1.693,0,0,1-.674-1.318,17.937,17.937,0,0,1,2.117-11.408,4.549,4.549,0,0,1,.463-.7,16.426,16.426,0,0,1-2.656-1.7s-4.795,17.994.853,16.532c4.881-1.263,14.36-5.031,17.458-5.839C208.411,983.891,205.464,986.01,203.625,986.491Z",
    transform: "translate(-189.732 -931.383)",
    fill: "#4a131e",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M249.951,821.137a13.164,13.164,0,0,1-3.015,1.064,7.347,7.347,0,0,0-5.054,7.182c0,4.168.081,7.419,2.883,10.222s2.7,2.9,4.3,4.5,5.9-.931,7.98-3.015,3.636-4.345,3.1-7.715-.089-5.143-1.685-8.424S251.825,819.263,249.951,821.137Z",
    transform: "translate(-227.332 -820.48)",
    fill: "#2b2018"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M252.241,847.862s-.414,5.695,2.174,7.507,1.553,5.591.777,6.368a3.921,3.921,0,0,0,2.64,5.954c4.142,1.035,6.834-4.142,6.109-5.591s-3.106-4.3-1.709-6.989,1.826-2.226,1.826-6.161-1.05-6.627-3.431-7.507S253.017,840.666,252.241,847.862Z",
    transform: "translate(-234.783 -835.32)",
    fill: "#fe9b7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M258.264,869.228a3.236,3.236,0,0,0-.883-.242,5.591,5.591,0,0,1-4.022-7.721c.239-.562.927-1.145.605-1.7a1.6,1.6,0,0,0-1.4-.636,12.636,12.636,0,0,0-.323,1.814s-.414,5.695,2.174,7.507,1.553,5.591.777,6.368a3.623,3.623,0,0,0-.557,2.677c.388-.029.607-.515.712-.914l.85-3.242a3.328,3.328,0,0,1,1.282-2.22c.484-.27,1.2-.412,1.255-.964A.8.8,0,0,0,258.264,869.228Z",
    transform: "translate(-234.783 -848.202)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M250.951,843.467s4.711.259,6.627-3.21,2.381-2.537,2.381-2.537,1.45.155,1.45,4.452,1.34,4.835,1.34,4.835,1.559,1.378,1.559-2.712-2.123-10.406-5.8-10.406S249.812,836.633,250.951,843.467Z",
    transform: "translate(-233.752 -830.148)",
    fill: "#2b2018"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M246.936,825.4a7.346,7.346,0,0,0-5.054,7.182,27.291,27.291,0,0,0,.368,5.513.909.909,0,0,0,.133-.029,1.32,1.32,0,0,0,.778-1.2c.044-.506-.055-1.018.015-1.521a3.751,3.751,0,0,1,1.552-2.272,14.609,14.609,0,0,0,2.174-1.788,2.517,2.517,0,0,0,.564-2.606,2.6,2.6,0,0,1-.842.858.89.89,0,0,1-1.1-.159c-.809-1.082,1.824-2.628,2.385-3.269a2.91,2.91,0,0,0,.629-1.189C248.119,825.057,247.593,825.219,246.936,825.4Z",
    transform: "translate(-227.332 -823.678)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M277.467,833.374c-.532-3.37-.089-5.143-1.685-8.424-1.243-2.555-4.576-4.579-6.875-4.465.076.452.682.855.945,1.236a5.591,5.591,0,0,1,.114,6.2c-.695,1.088-1.741,1.9-2.53,2.926a7.788,7.788,0,0,0-.28,8.877c.663.981,1.555,1.8,2.121,2.845a6.713,6.713,0,0,1,.584,4.379,12.741,12.741,0,0,1-1.674,4.155,15.764,15.764,0,0,0-.888,1.629c.128.041.262.08.4.114,4.142,1.035,6.834-4.142,6.109-5.591a17.4,17.4,0,0,1-2.015-4.154,15.131,15.131,0,0,0,2.57-2.018C276.447,839.005,278,836.744,277.467,833.374Z",
    transform: "translate(-244.65 -820.481)",
    fill: "#4a131e",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(10.196 43.277)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M255.762,1002.455s-2.533-23.42-1.9-26c0,0-.065-.276-.161-.76a.816.816,0,0,0-1.087.283c-.415.557.184,1.752.33,2.309a11.788,11.788,0,0,1,.311,3.4,17.757,17.757,0,0,1-11.874,16.25c-3.257,1.144-6.792,1.324-10.042,2.488a17.355,17.355,0,0,0-5.062,2.864l1.522.2a73.2,73.2,0,0,0-1.2,13.255,43.174,43.174,0,0,0,.386,5.038,30.752,30.752,0,0,0,10.905,2.562c1.374.088,2.75.109,4.125.085l-.252-5.88h1.686l.3,5.827c2.614-.113,5.227-.362,7.833-.611a17.285,17.285,0,0,0,5.766-1.244c.143-2.25.227-4.516.227-6.745a42.928,42.928,0,0,0-2.316-13.235Z",
    transform: "translate(-226.276 -975.594)",
    fill: "#4a131e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M328.079,979.177a9.311,9.311,0,0,0-1.629-2.005Z",
    transform: "translate(-298.501 -976.731)",
    fill: "#4a131e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3681",
    "data-name": "Group 3681",
    transform: "translate(-88.164 -83.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3678",
    "data-name": "Group 3678",
    transform: "translate(345.383 150.219)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166-2",
    "data-name": "Path 166",
    d: "M1796.427,1137.773h.928l1.57-95.18h-4.069Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#20c5a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167-2",
    "data-name": "Path 167",
    d: "M1794.857,1042.593h4.069l-.086,4.514-3.949-2.761Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#20c5a0",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3679",
    "data-name": "Group 3679",
    transform: "translate(271.749 150.219)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168-2",
    "data-name": "Path 168",
    d: "M1520.338,1137.773h.928l1.57-95.18h-4.068Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#159a7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_169-2",
    "data-name": "Path 169",
    d: "M1518.768,1042.593h4.068l-.086,4.514-3.948-2.761Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#20c5a0",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4913",
    "data-name": "Path 4913",
    d: "M1493.2,1041.082h88.109a.864.864,0,0,0,.864-.864h0a.864.864,0,0,0-.864-.864H1493.2a.864.864,0,0,0-.864.864h0A.864.864,0,0,0,1493.2,1041.082Z",
    transform: "translate(-1227.639 -889.999)",
    fill: "#20c5a0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3682",
    "data-name": "Group 3682",
    transform: "translate(-659.365 -325.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3676-2",
    "data-name": "Group 3676",
    transform: "translate(870.047 406.346)"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166-3",
    "data-name": "Path 166",
    d: "M1796.427,1123.646h.928l1.57-81.053h-4.069Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#5f6169"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167-3",
    "data-name": "Path 167",
    d: "M1794.857,1042.593h4.069l-.086,4.934-3.949-3.018Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3677-2",
    "data-name": "Group 3677",
    transform: "translate(796.414 406.346)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168-3",
    "data-name": "Path 168",
    d: "M1520.338,1123.646h.928l1.57-81.053h-4.068Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_169-3",
    "data-name": "Path 169",
    d: "M1518.768,1042.593h4.068l-.086,3.844-3.948-2.352Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4912-2",
    "data-name": "Path 4912",
    d: "M1493.2,1041.082h88.109a.864.864,0,0,0,.864-.864h0a.864.864,0,0,0-.864-.864H1493.2a.864.864,0,0,0-.864.864h0A.864.864,0,0,0,1493.2,1041.082Z",
    transform: "translate(-702.974 -633.873)",
    fill: "#555"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3683",
    "data-name": "Group 3683",
    transform: "translate(134.076 42.348)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 2.292,
    height: 49.992,
    transform: "translate(39.728 66.297)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M547.807,1112.847H522.815a24.494,24.494,0,0,1-13.652-16.1l-12.089-45.873a2.813,2.813,0,0,0-2.719-2.1h-8.386a2.151,2.151,0,0,0-1.093,0h0a2.154,2.154,0,0,0-1.534,2.631l12.093,45.886a26.673,26.673,0,0,0,25.775,19.862h26.6a2.153,2.153,0,1,0,0-4.307Z",
    transform: "translate(-483.269 -1048.703)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M546.143,1114.971H522.995c-6.59-2.964-13.565-8.307-15.5-15.635l-12.089-45.873a2.812,2.812,0,0,0-2.719-2.1H484.3a2.149,2.149,0,0,0-.979-.026,2.152,2.152,0,0,1,1.547-2.567h0a2.151,2.151,0,0,1,1.093,0h8.386a2.813,2.813,0,0,1,2.719,2.1l12.089,45.873a24.494,24.494,0,0,0,13.652,16.1H547.8a2.153,2.153,0,0,1,.441,4.261C548.034,1116.047,547.173,1114.971,546.143,1114.971Z",
    transform: "translate(-483.267 -1048.703)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M532.485,1381.947a29.415,29.415,0,0,1,22.5,0V1376.3c-6.514-2.517-13.6-3.583-22.5,0Z",
    transform: "translate(-502.938 -1259.059)",
    fill: "#222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3685",
    "data-name": "Group 3685",
    transform: "translate(70.545)"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4914",
    "data-name": "Path 4914",
    d: "M0,45.755l9.15-8.63a151.061,151.061,0,0,1,7.331-14.678c3.114-5.07,5.655-9.807,5.655-9.807a16.289,16.289,0,0,1,1.169-5.073A20.06,20.06,0,0,1,26.821,3.26a.807.807,0,0,1,.715,1.3c-.628,1.257-1.636,3.571-1.353,3.651s2.761-4.076,2.737-5.481.073-2.484.668-2.709,1.008,1.29,1.172,2.9a1.316,1.316,0,0,1,.925.649,2.517,2.517,0,0,1-.041,1.615s.081.039.3.442a11.007,11.007,0,0,1-2.3,6.708,15.432,15.432,0,0,1-2.926,2.631s-5.954,18.291-8.832,24.053a67.357,67.357,0,0,1-7.779,11.5Z",
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 63.146, 75.128)",
    fill: "#febac7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3686",
    "data-name": "Group 3686",
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 53.908, 73.683)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    "data-name": "Path 7",
    d: "M2.657,6.213A19.116,19.116,0,0,1,0,8.664,18.405,18.405,0,0,0,5,0C4.94,1.267,4.245,4.514,2.657,6.213Z",
    transform: "translate(19.918 0)",
    fill: "#4a131e"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    "data-name": "Path 8",
    d: "M19.28.025,19.292,0c-1.326,4.016-6.019,18.049-8.474,22.965a67.356,67.356,0,0,1-7.779,11.5L0,33.037c1.06-1.847,3.4-4.247,3.987-5.224,1.329-2.213,2.92-4.351,4.351-6.527,1.641-2.5,3.231-5.014,4.612-7.6C15.34,9.209,17.092,4.559,19.28.025Z",
    transform: "translate(0 9.932)",
    fill: "#4a131e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(29.1 70.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1654.258,1373.476v5.25a1.579,1.579,0,0,1-1.579,1.579h-2.836l-.232-.365a.68.68,0,0,0-1.163.025l-.2.34h-8.671a.651.651,0,0,1-.43-1.14l6.476-5.689Z",
    transform: "translate(-1626.746 -1286.931)",
    fill: "#031162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1614.085,1351.936l2.272,4.733a1.58,1.58,0,0,1-.74,2.107L1613.06,1360l-.367-.229a.68.68,0,0,0-1.038.526l-.03.391-7.817,3.752a.651.651,0,0,1-.88-.842l4.738-10.443Z",
    transform: "translate(-1600.307 -1271.136)",
    fill: "#031162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1601.718,1048.978l-8.467,48.558,6.195,33.789,8.643-1.031s-2.46-32.865-2.46-33.4,10.612-27.789,10.612-27.789l-3.782-15.85Z",
    transform: "translate(-1593.251 -1048.978)",
    fill: "#63371f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1653.7,1048.978s2.077,16.866-1.231,32.445-8.216,54.1-8.216,54.1h-8.963s.373-65.036,0-65.41-.415-7.792-4.1-10.521c-6.706-4.962-6.21-10.613-6.21-10.613Z",
    transform: "translate(-1616.508 -1048.978)",
    fill: "#8c4d2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(8.685 0.463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 6.78,
    height: 3.397,
    transform: "translate(6.873)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1692.436,1061.392H1678.9a.2.2,0,0,1,0-.4h13.536a.2.2,0,0,1,0,.4Z",
    transform: "translate(-1664.595 -1058.25)",
    fill: "#000d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1692.436,1052.1H1678.9a.2.2,0,1,1,0-.4h13.536a.2.2,0,1,1,0,.4Z",
    transform: "translate(-1664.595 -1051.439)",
    fill: "#000d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1632.248,1061.392h-6.233a.2.2,0,0,1,0-.4h6.233a.2.2,0,0,1,0,.4Z",
    transform: "translate(-1625.815 -1058.25)",
    fill: "#000d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1632.248,1052.1h-6.233a.2.2,0,0,1,0-.4h6.233a.2.2,0,1,1,0,.4Z",
    transform: "translate(-1625.815 -1051.439)",
    fill: "#000d41"
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M-.015,4.735l9.15,8.63a151.063,151.063,0,0,0,7.331,14.678c3.114,5.07,5.655,9.807,5.655,9.807a16.289,16.289,0,0,0,1.169,5.073,20.06,20.06,0,0,0,3.516,4.307.807.807,0,0,0,.715-1.3c-.628-1.257-1.636-3.571-1.353-3.651s2.761,4.076,2.737,5.481.073,2.484.668,2.709,1.008-1.29,1.172-2.9a1.316,1.316,0,0,0,.925-.649,2.517,2.517,0,0,0-.041-1.615s.081-.039.3-.442a11.007,11.007,0,0,0-2.3-6.708A15.432,15.432,0,0,0,26.7,35.526s-5.954-18.291-8.832-24.053a67.358,67.358,0,0,0-7.779-11.5Z",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 69.736, 37.318)",
    fill: "#febac7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1-2",
    "data-name": "Group 1",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 75.734, 41.039)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7-3",
    "data-name": "Path 7",
    d: "M2.657,2.451A19.117,19.117,0,0,0,0,0,18.406,18.406,0,0,1,5,8.664C4.94,7.4,4.245,4.15,2.657,2.451Z",
    transform: "translate(19.913 35.729)",
    fill: "#4a131e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8-3",
    "data-name": "Path 8",
    d: "M19.275,34.435l.012.025c-1.326-4.016-6.019-18.049-8.474-22.965A67.357,67.357,0,0,0,3.033-.01L0,1.423C1.056,3.27,3.4,5.67,3.982,6.647,5.311,8.86,6.9,11,8.333,13.174c1.641,2.5,3.231,5.014,4.612,7.6C15.335,25.251,17.087,29.9,19.275,34.435Z",
    transform: "translate(0 0)",
    fill: "#4a131e"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1605.786,868.272s20.852-1.06,22.013,0,10.365,17.974,10.365,17.974-.58,1.244-3.482,1.99-12.707,2.239-12.707,2.239l2.087,25.182a.982.982,0,0,1-.983,1.063l-29.807-.129a1,1,0,0,1-.991-.961l-1.047-27.726-8.872-3.98s5.472-13.018,6.633-13.6S1605.786,868.272,1605.786,868.272Z",
    transform: "translate(-1556.166 -845.207)",
    fill: "#ff6a19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1672.157,905.729c1.026-3.865.18-8-1.26-11.731s-3.459-7.217-4.9-10.946-2.3-7.861-1.284-11.729a3.456,3.456,0,0,1,3.478,1.744,9.717,9.717,0,0,0,2.385-3.864,3.573,3.573,0,0,1,.774-1.248c6.059-.2,13.559-.307,14.242.317,1.161,1.06,10.365,17.975,10.365,17.975s-.58,1.244-3.483,1.99-12.706,2.239-12.706,2.239l2.087,25.182a.982.982,0,0,1-.983,1.063l-19.7-.085C1666.215,914.722,1670.78,910.914,1672.157,905.729Z",
    transform: "translate(-1613.955 -845.207)",
    fill: "#262260",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1641.539,1135.522c1.572-20.742,6.062-59.088,6.611-61.33.692-2.826,1.384-5.8.611-8.6a11.873,11.873,0,0,0-4.83-6.283,45.812,45.812,0,0,0-7.147-3.753,103.041,103.041,0,0,1-11.8-6.5c0-.05,0-.077,0-.077h28.724s.025.208.066.6h0c.009.084.019.179.029.281,0,.017,0,.033,0,.051,0,.037.008.076.011.115s.005.057.009.086l.011.118c0,.034.006.069.01.1s.008.081.012.123.007.075.011.114.008.088.012.134.007.082.011.124.008.091.012.137.008.1.013.149.007.085.011.129.01.119.015.18l.01.12.025.312,0,.046c.007.093.015.188.022.285,0,.041.006.083.009.125.005.074.011.149.017.226,0,.045.007.092.01.138.005.075.011.152.016.229,0,.049.007.1.01.147q.007.116.015.235c0,.052.007.1.01.157.005.08.01.161.015.242,0,.053.007.105.01.159.005.088.01.177.016.267,0,.05.005.1.008.148.006.105.012.212.018.319,0,.036,0,.072.006.109q.024.44.046.907c0,.042,0,.086.006.129.005.113.01.226.015.342,0,.053,0,.108.007.162,0,.106.009.213.013.322q0,.09.007.18.006.158.011.318,0,.093.007.188c0,.108.007.217.01.327q0,.093.006.187c0,.115.007.232.01.35,0,.058,0,.116,0,.174,0,.134.007.271.01.407,0,.042,0,.084,0,.127q.012.543.019,1.108c0,.051,0,.1,0,.152l0,.415c0,.063,0,.126,0,.189,0,.129,0,.257,0,.387,0,.07,0,.14,0,.21v.6c0,.127,0,.254,0,.382,0,.072,0,.144,0,.217,0,.135,0,.271,0,.407,0,.066,0,.132,0,.2,0,.155,0,.312-.007.469,0,.048,0,.1,0,.145q-.011.622-.028,1.258c0,.058,0,.117-.005.175q-.007.228-.014.457l-.009.227c0,.138-.01.277-.015.416,0,.081-.007.163-.01.245-.005.135-.011.269-.017.4,0,.085-.008.17-.012.255-.006.135-.013.271-.02.406q-.006.126-.013.252c-.008.142-.016.284-.024.427,0,.079-.009.157-.013.236q-.014.238-.03.477-.006.095-.012.189-.043.67-.1,1.35c-.005.067-.011.135-.016.2-.013.157-.025.315-.039.473-.007.085-.015.169-.022.254q-.019.214-.038.429l-.026.272q-.019.207-.04.415-.014.139-.028.279-.022.208-.043.417c-.01.092-.02.183-.03.275q-.024.216-.049.432c-.01.087-.02.174-.03.261q-.028.24-.058.48c-.009.071-.017.142-.026.214q-.087.694-.185,1.391c-.011.075-.022.15-.033.225-.023.157-.045.314-.069.471-.013.09-.027.18-.041.27q-.033.215-.066.429l-.046.285c-.022.138-.045.276-.069.414-.016.1-.033.194-.049.29-.024.138-.048.276-.073.415l-.051.286q-.039.213-.079.427c-.017.09-.034.18-.051.271q-.045.234-.091.468c-.015.076-.03.152-.045.228q-.07.347-.143.693c-3.308,15.579-8.217,54.1-8.217,54.1Z",
    transform: "translate(-1587.418 -978.064)",
    fill: "#262260",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1770.746,938.855c-.656.169-1.665.375-2.833.595.008-.4.4-.8,1.78-.95a8.446,8.446,0,0,0,4.536-1.634S1773.648,938.109,1770.746,938.855Z",
    transform: "translate(-1692.23 -895.851)",
    fill: "#031162"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1638.708,805.556a41.14,41.14,0,0,1,.787,4.724c.158,1.968.473,4.251,3.149,5.117s2.283.63,2.283.63c.09,1.9-.964,2.956-1.719,4.542l4.125,3.095,5.939-3.729s-3.543-2.176-2.519-4.538a79.991,79.991,0,0,0,2.519-8.877s-1.843-3.49-5.19-4.156C1645.073,801.765,1640.646,803.879,1638.708,805.556Z",
    transform: "translate(-1597.485 -797.146)",
    fill: "#febac7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(41.223 7.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1639.5,816.3a41.143,41.143,0,0,0-.787-4.724,11.722,11.722,0,0,1,1.547-1.1,6.482,6.482,0,0,1-.123,1.729,30.582,30.582,0,0,0,.12,4.912,6.621,6.621,0,0,0,.646,2.518,5.546,5.546,0,0,0,1.673,1.76C1639.963,820.511,1639.651,818.253,1639.5,816.3Z",
    transform: "translate(-1638.708 -810.475)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1657.213,858.074a2.028,2.028,0,0,1,.186.331,3.32,3.32,0,0,1-.044,2.21,6.478,6.478,0,0,1-.7,1.683l-1.068-.8A15.882,15.882,0,0,0,1657.213,858.074Z",
    transform: "translate(-1651.082 -845.379)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M1650.665,834.015a1.907,1.907,0,0,0-1.883-.929c-1.341.129-2.347-.258-3.017,1.393,0,0-.284.438-.516.387a2.922,2.922,0,0,0,2.373,0c1.057-.6,1.083.2,2.167.265a2.2,2.2,0,0,0,1.547-.346S1650.613,834.5,1650.665,834.015Z",
    transform: "translate(-1602.281 -819.742)",
    fill: "#2e1b01"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1627.721,788.723a.014.014,0,0,0,.006-.012c0-.15-.036-2.718,2.182-3.525a12.614,12.614,0,0,1,4.411-.727l.008,0c.127-.068,3.48-1.856,6.333-1.245a7.137,7.137,0,0,1,4.362,3.427l0,0c.062.059,2.439,2.316,2.336,4.674a5.471,5.471,0,0,1-2.118,3.836.014.014,0,0,0,0,.02,2.709,2.709,0,0,1,.2,2.637,10.156,10.156,0,0,0-.489.969,12.367,12.367,0,0,1-2.786,3.961h0a.016.016,0,0,1-.027-.009l-.642-4.23a.016.016,0,0,1,.012-.018c.185-.035,2.008-.444,1.959-2.958-.052-2.649-1.195-2.337-1.87-2.078a1.709,1.709,0,0,0-.693.841.022.022,0,0,0,0,.006,8.6,8.6,0,0,1-.44,2.327v0a.711.711,0,0,1-.173.391h0s-.018.057-.049.154v.005c-.046.8,1.817,3.359.05,4.879-1.909,1.644-5.992,1.008-7.848,0-1.669-.906-1.285-3.482-1.19-3.993a.016.016,0,0,1,.031,0,2.276,2.276,0,0,0,2.7,1.722c.637-.148,1.538-.594,2.227-.151.56.36,1.923-.017,2.416-.171a.319.319,0,0,0,.218-.245h0a6.561,6.561,0,0,1,.762-2.958,18.769,18.769,0,0,0,.443-2.92.023.023,0,0,0,0-.008,2.456,2.456,0,0,0-.224-.417,3.5,3.5,0,0,1-.637-2.127l.031-.681a.016.016,0,0,0-.018-.017,45.836,45.836,0,0,1-5.423.539,9.312,9.312,0,0,0-3.381.755.016.016,0,0,0-.009.016l.11,1.24a.016.016,0,0,1-.022.017C1630.1,792.484,1625.644,790.416,1627.721,788.723Z",
    transform: "translate(-1589.025 -783.085)",
    fill: "#2e1b01"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M1638.041,785.808a5.84,5.84,0,0,1,.5-1.145c.073-.129.151-.254.232-.378.941-.448,3.635-1.577,5.99-1.073a7.137,7.137,0,0,1,4.363,3.427l0,0c.062.059,2.438,2.315,2.336,4.674a5.469,5.469,0,0,1-2.118,3.836.014.014,0,0,0,0,.02,2.709,2.709,0,0,1,.2,2.637,10.182,10.182,0,0,0-.489.969,12.357,12.357,0,0,1-2.782,3.956c.4,1.757,2.644,3.14,2.644,3.14l-1.372.861a5.388,5.388,0,0,0-1.567.984l-.166.1a1.351,1.351,0,0,0-.335-1.065,4.613,4.613,0,0,0-1.766-.909,7.106,7.106,0,0,1-3.251-2.667c.011-.045.022-.089.031-.135l-.124-.008a7.008,7.008,0,0,1-1.1-3.269,19.927,19.927,0,0,0-.136-2.8,2.368,2.368,0,0,0-1.746-1.97,8.408,8.408,0,0,0,1.117-4.532c-.041.008-.082.018-.123.023-1.076.141-2.252-.528-3.205-.009a6.523,6.523,0,0,0-.864.707,1.1,1.1,0,0,1-1.033.267.9.9,0,0,1-.512-.838,2.135,2.135,0,0,1,.294-.989A7.44,7.44,0,0,1,1638.041,785.808Z",
    transform: "translate(-1593.131 -783.085)",
    fill: "#febac7",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1726.877,900.561a.2.2,0,0,1-.2-.167c-1.892-12.148.963-16.751,1.086-16.941a.2.2,0,0,1,.332.214c-.029.046-2.892,4.693-1.027,16.666a.2.2,0,0,1-.165.226Z",
    transform: "translate(-1661.522 -856.619)",
    fill: "#000d41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M1612.415,902.25a.2.2,0,0,1-.2-.181l-1.057-12.153a.2.2,0,0,1,.18-.214.194.194,0,0,1,.214.18l1.057,12.153a.2.2,0,0,1-.18.214Z",
    transform: "translate(-1577.284 -861.267)",
    fill: "#000d41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M1679.393,875.33l-3.449-1.872a.2.2,0,0,1,.188-.347l3.081,1.672,2.057-4.381a.2.2,0,0,1,.358.168Z",
    transform: "translate(-1624.713 -847.031)",
    fill: "#000d41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M1652.782,877.024l-1.243-4.208a.2.2,0,0,1,.379-.112l1.1,3.721,2.324-1.379a.2.2,0,0,1,.2.34Z",
    transform: "translate(-1606.888 -848.698)",
    fill: "#000d41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M1668.863,887.986q-.04,0-.081,0a.976.976,0,1,1,.081,0Zm0-1.563a.585.585,0,0,0-.582.536h0a.584.584,0,0,0,.534.629.584.584,0,0,0,.095-1.164Zm-.779.52h0Z",
    transform: "translate(-1618.879 -858.573)",
    fill: "#000d41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1668.863,897.942q-.04,0-.081,0a.981.981,0,1,1,.081,0Zm0-1.562a.585.585,0,0,0-.582.536h0a.584.584,0,1,0,.629-.534Zm-.779.52h0Z",
    transform: "translate(-1618.879 -865.874)",
    fill: "#000d41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1492.339,1040.219Z",
    transform: "translate(-1497.617 -971.007)",
    fill: "#20c5a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDeskIllustration);
export default __webpack_public_path__ + "static/media/noDeskIllustration.35fa09dcac91791ea0228e92a1c13b13.svg";
export { ForwardRef as ReactComponent };